import { BackendModel, BackendService } from '../core/backend.service';

export class TipoConfiguracion extends BackendModel {

  static path = '/configuraciones/';

  id: number;
  description: String;
  created: Date;
  updated: Date;
  deleted: Date;

  constructor(protected backendService: BackendService, model?: TipoConfiguracion) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/configuracion/tipoConfiguracion.model.ts